import React from "react"
import styled from "styled-components"
import homeIcon from "../../images/home-icon.svg";
import { truncateString, getCookie } from "../../utils/helpers"

const CtaBanner = styled.section`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: var(--space-md) 0;
    z-index: 100;
    box-shadow: 0 -0.5rem 0.75rem rgba(0, 0, 0, 0.2) !important;
    background-color: #08464d;
    color: #90ebf6;
    .cta-banner-title {
        font-size: 28px;
    }
    .cta-banner-subtitle{
        font-size: 16px;
        font-family: inherit;
    }
    .cta-banner__content{
        justify-content: space-around;
    }
    .button-primary, .button-primary:hover{
        color: var(--orange-text);
    }
    .cta-banner__br{
        display: none;
    }
    @media screen and (max-width: 1200px) {
        .cta-banner-title {
            font-size: 24px;
        }
    }
    @media screen and (max-width: 900px) {
        .cta-banner-title {
            font-size: 18px;
        }
        .cta-banner__texts{
            max-width: 500px;
        }
    }
    @media screen and (min-width: 200px) and (max-width: 768px) {
        padding: var(--space-xs) 0;
        .cta-banner-title {
            font-size: 18px;
            margin-bottom: 4px;
        }
        .cta-banner-subtitle{
            font-size: 14px;
            line-height: 120%;
        }
        .cta-banner__icon{
            padding-right: 20px;
            img{
                width: 40px;
            }
        }
    }
    @media screen and (max-width: 767px){
        .cta-banner__icon{
            padding-bottom: 10px;
            padding-right: 0;
            img{
                width: 40px;
            }
        }
        .cta-banner__texts{
            padding-bottom: 10px;
        }
        .cta-banner__content{
            flex-direction: column;
            text-align: center;
            .cta-banner-subtitle{
                display: none;
            }
        }
        .cta-banner__button{
            .button-primary{
                display: block;
                padding: 8px 20px;
            }
        }
        .cta-banner__br{
            display: block;
        }
        .cta-banner__icon{
            display: none;
        }
        .cta-banner-title{
            font-size: 16px;
            margin-bottom: 0;
        }
    }
`

export default ({ fromPage, category }) => {
    const handleClick = e => {
        e.preventDefault()
        const allId = getCookie("ehi.alliance_id")
        const redirectURLs = {
            "Individual and Family": `https://www.${process.env
                .GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/individual-family-health-insurance${
                allId ? `?allid=${allId}` : ""
            }`,
            "Small Business": `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/small-business-health-insurance/group-health-insurance-plans${
                allId ? `?allid=${allId}` : ""
            }`,
            "Medicare": `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthmedicareplans.com/v2
            `,
            "Coronavirus Updates and Resources": `https://www.${process.env
                .GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com${allId ? `?allid=${allId}` : ""
            }`,
        }
        window._waEvents.push("trackEvent", {
            page: { action: `${truncateString(fromPage, 50)}:find plans` },
            events: ["find plans"],
        })
        window.location.href = redirectURLs[category] ? redirectURLs[category] : redirectURLs["Individual and Family"]
    }
    return (
        <CtaBanner className="cta-banner">
            <div className="container-lg">
                <div className="row no-gutters cta-banner__content align-items-center">
                    <div className="cta-banner__icon text-center">
                        <img src={homeIcon}/>
                    </div>
                    <div className="cta-banner__texts">
                        <h3 className="cta-banner-title mr-md-4">
                            Compare hundreds of<br className="cta-banner__br"/> affordable plans in your area.
                        </h3>
                        <div className="cta-banner-subtitle">See how free quotes and more options can help you find the right health insurance plan.</div>
                    </div>
                    <div className="cta-banner__button text-center">
                        <a className="button-primary" onClick={handleClick}>Get Quotes</a>
                    </div>
                </div>
            </div>
        </CtaBanner>
    )
}
